<template>
    <Head
        ><title>{{ t("pages.mobileAppDownload.title") }}</title></Head
    >
    <main class="page safe-area-top">
        <div class="content fade-in">
            <img :src="Logo" :alt="t('common.valenceLogoAlt')" class="logo" />
            <div class="intro">
                <h1 class="display-serif">{{ t("pages.mobileAppDownload.heading") }}</h1>
                <p class="body-small text-ink-muted">{{ t("pages.mobileAppDownload.subtitle") }}</p>
            </div>
            <div class="stores">
                <BaseCard padding="lg" radius="xl" class="store-card">
                    <i class="platform-icon bi bi-apple" aria-hidden="true"></i>
                    <h2 class="title-body-bold">{{ t("pages.mobileAppDownload.iphone") }}</h2>
                    <QrcodeSvg
                        :value="app_store_url"
                        :size="160"
                        :margin="2"
                        level="M"
                        class="qr-code"
                        role="img"
                        :aria-label="t('pages.mobileAppDownload.qrCodeAlt', { platform: t('pages.mobileAppDownload.iphone') })" />
                    <p class="scan-instruction">{{ t("pages.mobileAppDownload.scanInstruction") }}</p>
                    <a :href="app_store_url" target="_blank" rel="noopener noreferrer" class="base-btn-primary">{{
                        t("pages.mobileAppDownload.downloadFor", { platform: t("pages.mobileAppDownload.iphone") })
                    }}</a>
                </BaseCard>
                <BaseCard padding="lg" radius="xl" class="store-card">
                    <i class="platform-icon bi bi-android2" aria-hidden="true"></i>
                    <h2 class="title-body-bold">{{ t("pages.mobileAppDownload.android") }}</h2>
                    <QrcodeSvg
                        :value="play_store_url"
                        :size="160"
                        :margin="2"
                        level="M"
                        class="qr-code"
                        role="img"
                        :aria-label="t('pages.mobileAppDownload.qrCodeAlt', { platform: t('pages.mobileAppDownload.android') })" />
                    <p class="scan-instruction">{{ t("pages.mobileAppDownload.scanInstruction") }}</p>
                    <a :href="play_store_url" target="_blank" rel="noopener noreferrer" class="base-btn-primary">{{
                        t("pages.mobileAppDownload.downloadFor", { platform: t("pages.mobileAppDownload.android") })
                    }}</a>
                </BaseCard>
            </div>
            <a :href="home_url" class="base-btn-tertiary text-ink hover:bg-surface-hover">{{ t("pages.mobileAppDownload.continueToNadia") }}</a>
        </div>
    </main>
</template>

<script setup lang="ts">
import { Head } from "@inertiajs/vue3";
import Logo from "~img/color-logo.svg";
import BaseCard from "~vue/components/BaseCard.vue";
import { QrcodeSvg } from "qrcode.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

defineProps<{
    app_store_url: string;
    play_store_url: string;
    home_url: string;
}>();
</script>

<style scoped>
@reference "../../../css/tailwind.css";

@layer components {
    .page {
        @apply flex min-h-screen flex-col overflow-y-auto bg-surface text-ink;
    }

    .content {
        @apply flex grow flex-col items-center justify-center gap-10 px-4 py-10 text-center;
    }

    .logo {
        @apply h-16 w-auto;
    }

    .intro {
        @apply flex max-w-md flex-col gap-2;
    }

    .stores {
        @apply grid w-full max-w-2xl gap-6 sm:grid-cols-2;
    }

    .store-card {
        @apply flex flex-col items-center gap-3;
    }

    .platform-icon {
        @apply text-4xl text-ink;
    }

    .qr-code,
    .scan-instruction {
        @apply hidden sm:block;
    }

    .scan-instruction {
        @apply body-small text-ink-muted;
    }
}
</style>
